/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import '@/payment-services/components/CreditCardForm/CreditCardField.css';
import { classes } from '@adobe-commerce/elsie/lib';
import { FunctionComponent } from 'preact';
import { HTMLAttributes } from 'preact/compat';

export interface CreditCardFieldProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'size'> {
  containerId: string;
  error?: string;
  label?: string;
}

export const CreditCardField: FunctionComponent<CreditCardFieldProps> = ({
  className,
  containerId,
  label,
  error,
  children,
  ...props
}) => {
  return (
    <div {...props} className={classes(['credit-card-field', className])}>
      {label && <div className="credit-card-field__label">{label}</div>}

      <div
        id={containerId}
        data-testid={containerId}
        className={classes([
          'credit-card-field__container',
          ['credit-card-field__container--error', !!error],
        ])}
      />

      <div className="credit-card-field__error">{error}</div>
    </div>
  );
};
